import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";

const LOGO_URL = "/logo.png";
const navLinks = [
{ label: "How It Works", href: "#how-it-works" },
{ label: "Destinations", href: "#visa-search" },
{ label: "Testimonials", href: "#testimonials" },
{ label: "FAQ", href: "#faq" }];


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    if (window.location.pathname !== "/") {navigate("/");setTimeout(() => {document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });}, 300);return;}
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav data-testid="navbar" initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.5 }}
    className={`fixed top-0 left-0 right-0 z-50 glass-nav transition-all ${scrolled ? "py-2 shadow-sm" : "py-3"}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button onClick={() => navigate("/")} data-testid="navbar-logo" className="flex items-center">
          <img src={LOGO_URL} alt="Fly In Visa" className="h-14 w-auto object-contain rounded-lg" />
        </button>
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) =>
          <button key={l.href} onClick={() => scrollTo(l.href)} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
          className="text-sm text-slate-500 hover:text-blue-600 transition-colors font-medium">{l.label}</button>
          )}
        </div>
        <div className="hidden md:flex items-center gap-3">
          {user ?
          <>
              <NotificationBell />
              <button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard"
            className="text-sm text-slate-600 px-4 py-2 rounded-lg hover:bg-slate-100 transition-all flex items-center gap-2 font-medium">
                <User className="w-4 h-4" /> Dashboard
              </button>
              <button onClick={logout} data-testid="nav-logout" className="text-sm text-slate-400 px-3 py-2 hover:text-slate-600">Logout</button>
            </> :

          <>
              <button onClick={() => navigate("/login")} data-testid="nav-login"
            className="text-sm text-slate-600 px-4 py-2 rounded-lg hover:bg-slate-100 transition-all font-medium">Sign In</button>
              <button onClick={() => navigate("/register")} data-testid="nav-apply-now"
            className="text-sm text-white font-semibold bg-blue-600 px-5 py-2.5 rounded-lg hover:bg-blue-700 transition-all shadow-sm">Get Started</button>
            </>
          }
        </div>
        <button className="md:hidden text-slate-700 p-2" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      <AnimatePresence>
        {mobileOpen &&
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
        className="md:hidden overflow-hidden border-t border-slate-100">
            <div className="px-6 py-4 flex flex-col gap-3 bg-white">
              {navLinks.map((l) =>
            <button key={l.href} onClick={() => scrollTo(l.href)} className="text-left text-slate-600 hover:text-blue-600 py-2">{l.label}</button>
            )}
              <button onClick={() => {setMobileOpen(false);navigate(user ? "/dashboard" : "/register");}}
            className="mt-2 text-sm text-white font-semibold bg-blue-600 px-5 py-3 rounded-lg text-center">{user ? "Dashboard" : "Get Started"}</button>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    </motion.nav>);

}